<template>
    <div class="doubleArea" ></div>
</template>

<script>
export default {
    name: '',
    props: {
        // selectRangeDate: Array,
        pondsid:Number,
        companyId: Number,
        greenhouseId: Number
    },
    data() {
        return {
            myChart: null,
            xData:[],
            fullDateData: [], // 保存完整的日期时间，用于tooltip显示
            yData:{
                temp1: [],
                temp2: [],
                temp3: []
            },
            timerSetChart: null, // 用于存储setChart的定时器
            timerGetData: null, // 用于存储getData的定时器// 用于存储动态的y轴最小值
        }
    },
    methods: {
        updateWithDateRange(start, end) {
            // 使用新的 /sensors/history-by-time 接口，支持精确时间
            const params = {
                greenhouseId: this.greenhouseId,
                startDate: start,
                endDate: end,
                pageNum: 1,
                pageSize: 1000 // 获取足够多的数据用于图表显示
            };
            this.request.get("/api/sensors/history-by-time", {
                params: params
            }).then(res => {
                // 处理返回结果，支持 Result 包装格式
                const list = Array.isArray(res) ? res :
                             (res && Array.isArray(res.data)) ? res.data :
                             (res && Array.isArray(res.records)) ? res.records : [];
                // 保存完整日期时间用于tooltip
                this.fullDateData = list.map(item => item.createdAt);
                // 横坐标只显示时间
                this.xData = list.map(item => {
                    const dateTime = item.createdAt ? item.createdAt.split('T') : []
                    return dateTime[1] ? dateTime[1].substring(0, 5) : '' // 只显示时:分
                })
                this.yData = {
                    temp1: list.map(item => item.temp1 != null ? item.temp1 : 0),
                    temp2: list.map(item => item.temp2 != null ? item.temp2 : 0),
                    temp3: list.map(item => item.temp3 != null ? item.temp3 : 0)
                }
                this.setChart();
            }).catch(err => {
                console.error('获取历史数据失败:', err);
            });
        },
        setData(){
            this.request.get("/api/sensors/latest",{
                params:{
                    companyId: this.companyId,
                    greenhouseId: this.greenhouseId
                }
            }).then(res => {
                const list = Array.isArray(res) ? res : [];
                // 保存完整日期时间用于tooltip
                this.fullDateData = list.map(item => item.createdAt);
                // 横坐标只显示时间
                this.xData = list.map(item => {
                    const dateTime = item.createdAt.split('T')
                    return dateTime[1] ? dateTime[1].substring(0, 5) : '' // 只显示时:分
                })
                this.yData = {
                    temp1: list.map(item => item.temp1 != null ? item.temp1 : 0),
                    temp2: list.map(item => item.temp2 != null ? item.temp2 : 0),
                    temp3: list.map(item => item.temp3 != null ? item.temp3 : 0)
                }
                this.setChart();
            })
        },

        setChart() {
            const self = this; // 保存this引用
            let option = {
                color:'#fff',
                title: {
                    text: '温度变化曲线',
                    left: "center",
                    textStyle: {
                        color: "#fff",
                    }
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                    type: 'line',
                    },
                    formatter: function(params) {
                        let result = '';
                        if (params && params.length > 0) {
                            const index = params[0].dataIndex;
                            const fullDate = self.fullDateData[index];
                            // 格式化完整日期时间
                            if (fullDate) {
                                const dateTime = fullDate.replace('T', ' ');
                                result = dateTime + '<br/>';
                            }
                            params.forEach(param => {
                                result += `${param.seriesName}: ${param.value}°C<br/>`;
                            });
                        }
                        return result;
                    }
                },
                style: {
                text: '暂无此参数数据',
                textAlign: 'center',
                fill: '#ccc', // 文本颜色
                fontSize: 25
                },
                grid: {
                    right:'10%',
                    axisLine: {
                        type: 'dashed',
                        color: '#fff',
                    }
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: true,
                    axisLabel: {
                        textStyle: {
                            color: "#fff",
                        },
                    },
                    data: this.xData
                },
                yAxis: {
                    type: 'value',
                    axisLabel: {
                        formatter: '{value}',
                        textStyle: {
                            color: "#fff",
                        }
                    },
                    splitLine: { // 设置 y 轴网格线
                        show: true, // 显示网格线
                        lineStyle: { // 网格线的样式
                            color: '#88cbf2', // 颜色
                            type: 'dashed' // 线型，这里是虚线
                        }
                    },
                    // 吸附功能
                    axisPointer: {
                        snap: true,
                    },
                    name: '(°C)',
                        nameTextStyle: {
                            color: '#fff',
                            fontSize: 11,
                            align: 'right',
                        },
                },
                legend: {
                    data: ['温度1', '温度2', '温度3'],
                    left: 'left',
                    top: 'top',
                    orient: 'horizontal',
                    itemGap: 20,
                    selected: {
                        '温度1': true,
                        '温度2': true,
                        '温度3': true
                    },
                    textStyle: {
                        color: '#fff'
                    }
                },
                series: [
                    {
                    name: '温度1',
                    type: 'line',
                    smooth: true,
                    data: this.yData.temp1,
                    animation: true,
                    animationDuration: 2000,
                    animationDelay: function (idx) {
                        return idx * 300;
                    },
                    animationEasing: 'elasticOut',
                    itemStyle: {
                        color: '#ff6b6b'
                    }
                    },
                    {
                    name: '温度2',
                    type: 'line',
                    smooth: true,
                    data: this.yData.temp2,
                    animation: true,
                    animationDuration: 2000,
                    animationDelay: function (idx) {
                        return idx * 300;
                    },
                    animationEasing: 'elasticOut',
                    itemStyle: {
                        color: '#4ecdc4'
                    }
                },
                    {
                    name: '温度3',
                    type: 'line',
                    smooth: true,
                    data: this.yData.temp3,
                    animation: true,
                    animationDuration: 2000,
        animationDelay: function (idx) {
                        return idx * 300;
        },
                    animationEasing: 'elasticOut',
                    itemStyle: {
                        color: '#ffe66d'
                    }
                    }
                ]
            }   
            if (!this.myChart) this.myChart = this.$echarts(this.$el);
            this.myChart.clear();
            this.myChart.resize();
            this.myChart.setOption(option);
        },
    },
    watch: {
        pondsid() {
            this.setData();
        },
        greenhouseId() {
            this.setData();
        },
        companyId() {
            this.setData();
        }
    },
    mounted() {
        // 移除 mounted 中的 setData，只依赖 watch 触发
        // 启动定时器，每2分钟刷新图表，每5分钟获取新数据
        this.timerSetChart = setInterval(() => {
            this.setChart();
        }, 2 * 60 * 1000); // 2分钟

        this.timerGetData = setInterval(() => {
            // 只有当有有效数据时才刷新
            if (this.greenhouseId) {
                this.setData();
            }
        }, 5 * 60 * 1000); // 5分钟
    },
    beforeDestroy() {
        // 清除定时器
        clearInterval(this.timerSetChart);
        clearInterval(this.timerGetData);
    }
}
</script>

<style lang="less" scoped>
.doubleArea {
    margin-top: 5%;
    width: 98%;
    height: 100%;
}
</style>
